'use client'
import { useState } from 'react'
import { Typography, LinkButton } from 'components/Contentful'
import { Slider } from '@achieve/ascend'

export const SliderWithCta = ({
  defaultValue,
  step,
  minValue,
  maxValue,
  maxPlus,
  buttonLink,
  buttonText,
  sectionVariationObject,
  stylesClassOverride = {},
}) => {
  const dollarUSLocale = Intl.NumberFormat('en-US')
  const [sliderValue, setSliderValue] = useState(defaultValue || 20000)
  function handleChange(e) {
    setSliderValue(e.target.value)
  }
  return (
    <>
      <Typography
        content={`$${dollarUSLocale.format(sliderValue)}${
          sliderValue === maxValue && maxPlus ? '+' : ''
        }`}
        variant="displayMd"
        fontWeight="bold"
        className={
          stylesClassOverride?.title
            ? stylesClassOverride.title
            : 'text-blue-500 text-center md:mb-2'
        }
        data-testid="product-hero-dollar-value"
      />
      <Slider
        aria-label="dollar-amount-selection-slider"
        className="w-full"
        classes={{
          mark: 'hidden',
        }}
        data-testid="product-hero-slider-input"
        value={sliderValue}
        step={Number(step)}
        min={Number(minValue)}
        max={Number(maxValue)}
        marks={[
          {
            value: Number(minValue),
            label: (
              <Typography
                content={`$${dollarUSLocale.format(Number(minValue))}`}
                variant="bodySm"
                fontWeight="medium"
                className="ml-[50px] text-[#42546B]!"
                data-testid="product-hero-slider-min"
              />
            ),
          },
          {
            value: Number(maxValue),
            label: (
              <Typography
                content={`$${dollarUSLocale.format(Number(maxValue))}${maxPlus ? '+' : ''}`}
                variant="bodySm"
                fontWeight="medium"
                className="ml-[-55px] text-[#42546B]!"
                data-testid="product-hero-slider-max"
              />
            ),
          },
        ]}
        onChange={handleChange}
      />
      <LinkButton
        track={{
          list_name: 'Hero Form',
          click_id: buttonText,
          hero_card_text: buttonText,
          form_ss_amount: sliderValue,
          click_position: '0',
          nav_link_section: 'Hero Form',
          track_event: 'internal_campaign_click',
          event_action: 'button_click',
          event_type: 'button_click',
          sectionVariationObject,
        }}
        className="w-full py-2 mt-2 font-bold!"
        typographicOptions={{ fontWeight: 'bold' }}
        content={{
          linkHref: `${buttonLink}&loan_amount=${sliderValue}`,
          linkText: buttonText,
        }}
      />
    </>
  )
}
